export default "__VITE_ASSET__NR5be9nI__"